import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useInboxText } from '@platform/features/users/inbox/useInboxText';
import { useSince } from '@platform/features/users/inbox/useSince';
import type { INotificationRowProps } from './INotificationRowProps';

/**
 * Рядок сповіщення (прототип v4 G:L256): крапка 7px (акцент — непрочитане, колір небезпеки — прострочене нагадування, прозора — прочитане),
 * текст у форматі прототипу («Строк 28 жовт.: TSK-3 · назва», «Прострочено: …», «Хто прокоментував(-ла) …»), під ним 11px «Вид · Робочий
 * простір · коли» (час — як since прототипу: «щойно», «12 хв тому»); наведення — --surface2; клік позначає прочитаним і відкриває запис.
 */
export function NotificationRow({ entry, workspaceName, onOpen }: INotificationRowProps) {
  const { t } = useTranslation();
  const since = useSince();
  const { text } = useInboxText()(entry);
  return (
    <button type="button" role="menuitem" className="tb-notif__row" onClick={() => onOpen(entry)}>
      <span className={cx('tb-notif__dot', !entry.read && (entry.late ? 'is-late' : 'is-unread'))} aria-hidden="true" />
      <span className="tb-notif__body">
        <span className="tb-notif__text">{text}</span>
        <span className="tb-notif__meta">{[t(`inboxPage.kinds.${entry.kind}`), workspaceName, since(entry.at)].join(' · ')}</span>
      </span>
    </button>
  );
}
